module.exports = {
	SET_BENEFICIARY_DETAILS: 'set_beneficiary_details',
	SET_PHONE: 'set_phone',
	SET_TOKEN: 'set_token',
	SET_PHOTO: 'set_photo',
	RESET: 'reset',
	SET_LOADING: 'set_loading',
	SET_ID_IMAGE: 'set_id_image'
};
